import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SimpleImageLoader from './SimpleImageLoader';
import './PhotoCard.css';

const PhotoCard = ({ photo }) => {
  const location = useLocation();
  const photoId = photo.PK?.replace('PHOTO#', '') || '';

  return (
    <div className="photo-card" data-testid="photo-card">
      <Link 
        to={`/photo/${photoId}`} 
        state={{ from: location.search }}
        className="photo-link"
      >
        <div className="photo-image-container">
          <SimpleImageLoader
            photo={photo}
            size="medium"
            className="photo-image"
          />
        </div>
        <div className="photo-info">
          <h3 className="aircraft-info">
            {photo.aircraftType || 'Unknown Aircraft'}
          </h3>
          <p className="registration">{photo.registration || 'N/A'}</p>
          <div className="photo-details">
            <span className="operator">{photo.operator || 'Unknown Operator'}</span>
            <span className="location">{photo.iata || 'Unknown Airport'}</span>
          </div>
          {photo.photoDate && (
            <p className="photo-date">{new Date(photo.photoDate).toLocaleDateString()}</p>
          )}
        </div>
      </Link>
    </div>
  );
};

export default PhotoCard;